// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-30e8d66e]{margin:0;padding:0;box-sizing:border-box}.checkbox[data-v-30e8d66e]{width:24px;height:24px;min-width:24px;min-height:24px;display:inline-block;cursor:pointer;color:#fff;font-weight:400;font-size:16px;color:#21599d;border:2px solid #999;background:#fff 0 0 no-repeat padding-box}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
